<div class="section-edit-sheet">
  <div class="section-edit-sheet__handle" aria-hidden="true"></div>

  <div class="section-edit-sheet__header">
    <h2 [id]="titleId" class="section-edit-sheet__title">{{ title }}</h2>
    <button
      type="button"
      class="section-edit-sheet__close"
      [attr.aria-label]="'Close'"
      (click)="cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="section-edit-sheet__body">
    <!-- Variant B: a per-section sub-note under the title (Fable copy). -->
    <p class="section-edit-sheet__rekyc-note">{{ subNote }}</p>

    <form (ngSubmit)="save()" [class.show-form-error]="showFormError">
      <div class="row">
        <app-identity-section-form
          *ngIf="section === 'identity'"
          [profile]="profile"
          [role]="role"
          [showFormError]="showFormError"
        >
        </app-identity-section-form>
      </div>

      <app-contact-section-form
        *ngIf="section === 'contact'"
        [profile]="profile"
        [role]="role"
        [showFormError]="showFormError"
      >
      </app-contact-section-form>

      <app-employment-section-form
        *ngIf="section === 'employmentIncome'"
        [profile]="profile"
        [role]="role"
        [showFormError]="showFormError"
      >
      </app-employment-section-form>

      <app-income-transaction-section-form
        *ngIf="section === 'employmentIncome'"
        [profile]="profile"
        [role]="role"
        [showFormError]="showFormError"
      >
      </app-income-transaction-section-form>

      <app-bank-section-form
        *ngIf="section === 'bank'"
        [paymentMethod]="paymentMethod"
        [showFormError]="showFormError"
      >
      </app-bank-section-form>

      <div class="section-edit-sheet__footer">
        <button type="button" class="btn btn-outline-secondary section-edit-sheet__btn" (click)="cancel()">
          {{ 'common.cancel' | translate }}
        </button>
        <button type="submit" class="btn btn-primary section-edit-sheet__btn">
          {{ 'common.update' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
